var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sq-footer"},[_vm._v(" Made w/ love @ "),_c('a',{attrs:{"target":"_blank","href":"https://sqreen.io"}},[_vm._v("Sqreen")])])}]

export { render, staticRenderFns }